<template>
  <div class="home">
    <div class="text">
      <h3>Sistema para gravação de chassi em vidros automotivos</h3>
      <div>
        Os vidros de reposição também devem conter o número do chassi.
        <br>
        A ausência do número do chassi nos vidros é considerada infração grave e está sujeita a multa de <strong>R$195,23</strong> e retenção do veículo.
        <br><br>
        <strong>1º </strong>Selecione a fonte desejada no menu Fontes.
        <br>
        <strong>2º </strong>Informe o chassi.
        <br>
        <strong>3º </strong>Selecione o tipo de impressora.
        <br>
        <strong>4º </strong>Clique em Imprimir.
      </div>
    </div>
    <div class="form">
      <label>Chassi</label>
      <input :style="{ 'font-family': font }" type="text" class="form-control input-chassi">
      <label class="label">{{ label }}</label>
      <br>
      <button @click="printChassiMatricial()" class="btn btn-primary mr-3" @sendFont="readFont"><img src="../../assets/img/printer-matricial-24.png" class="pr-2">Matricial</button>
      <button @click="printChassiTermica()" class="btn btn-success" @sendFont="readFont"><img src="../../assets/img/printer-termica-24.png" class="pr-2">Térmica</button>
    </div>
    <div class="banner">
        <router-link to="/productsList">
          <img
            v-if="announcementStart"
              :src=announcementStart
              alt="Foto Anúncio"
          >
        </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data: () => ({
    font: '',
    label: '',
    chassi: '',
    radio: 'Matricial',
    announcementStart: ''
  }),
  methods: {
    readFont () {
      if (this.$route.params.font) {
        this.font = this.$route.params.font
        this.label = this.$route.params.label
        this.chassi = this.$route.params.chassi
        if (this.chassi) {
          document.querySelector('input').value = this.chassi
        }
      }
    },
    printChassiMatricial () {
      const inputChassi = document.querySelector('input').value.toUpperCase()

      if (inputChassi) {
        this.$router.push({ name: 'printMatricial', params: { font: this.font, label: this.label, chassi: inputChassi } })

        this.readFont()
      } else {
        this.$root.$emit('Notification::show', {
          message: 'Favor informar o chassi.',
          type: 'warning'
        })
      }
    },
    printChassiTermica () {
      const inputChassi = document.querySelector('input').value.toUpperCase()

      if (inputChassi) {
        this.$router.push({ name: 'printTermica', params: { font: this.font, label: this.label, chassi: inputChassi } })

        this.readFont()
      } else {
        this.$root.$emit('Notification::show', {
          message: 'Favor informar o chassi.',
          type: 'warning'
        })
      }
    },
    getAnnouncementStart () {
      this.ref = this.$firebase.database().ref('parameters/announcementStart')
        .on('value', (data) => {
          this.announcementStart = data.val()
        })
    }
  },
  mounted () {
    this.getAnnouncementStart()
    this.readFont()
    document.querySelector('input').focus()
  }
}
</script>

<style lang="scss" scoped>
.home {
  padding: 40px 60px;
  .text h3 {
    color: #0082e6;
    margin-bottom: 15px;
  }
  .text div {
    font-size: 18px;
  }
  .form {
    margin-top: 15px;
  }
  .form .input-chassi {
    width: 320px;
    text-transform: uppercase;
    font-size: 22px;
    font-weight: bold;
    color: #000000;
    letter-spacing: 3px;
    margin-bottom: 10px;
  }
  .form .radio-printer {
    margin-right: 5px;
  }
  .form button {
    padding: 7px 25px;
  }
  .form .label {
    position: absolute;
    left: 178px;
    font-size: 12px;
    font-style: italic;
    color: rgb(116, 116, 116);
    text-align: end;
    width: 200px;
  }
  .banner {
    margin-top: 25px;
    text-align: center;
  }
}
@media (min-height: 755px) {
  .home {
    .banner {
      position: absolute;
      bottom: 160px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
// PARA NÃO SAIR NO FUNDO DA IMPRESSAO ERRO DO CHROME
@media print {
      .home  {
      display: none !important;
    }
  }
</style>
